import React from 'react'
import cs from 'classnames'
import Banner from 'elements/Banner'
import CookieBanner from 'elements/CookieBanner'
import i18n from 'lib/i18n'
import styles from './CookieBar.scss'
const _ = i18n('cookieBar')

export const CookieBar = ({className, handleAcceptCookies}) => {
	return (
		<div>
			{ isClient ?
				<CookieBanner
					className={cs(styles.cookies, className)}
					buttonText={_('cookieConsent')}
					handleAcceptCookies={handleAcceptCookies}
				>
					<p>{_('clientText1')}</p>
					<p>{_('clientText2')}</p>
					<p>
						{_('clientText3')}
						<a href={_('clientLink')}>
							{_('clientLinkText')}
						</a>
					</p>
				</CookieBanner>
				:
				<CookieBanner
					className={cs(styles.cookies, className)}
					buttonText={_('cookieConsent')}
					handleAcceptCookies={handleAcceptCookies}
				>
					<p>{_('brokerText1')}</p>
					<p>{_('brokerText2')}</p>
					<p>
						{_('brokerText3')}
						<a href={_('brokerLink')}>
							{_('brokerLinkText')}
						</a>
					</p>
				</CookieBanner>
			}
		</div>
	)
}

export default CookieBar



// WEBPACK FOOTER //
// ./components/CookieBar.jsx